export const setCookie = (name, value, days = 7) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 86400000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

// ДОБАВИТЬ эту функцию
export const getCookieJSON = (name) => {
  const value = getCookie(name);
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (e) {
    console.error(`Failed to parse cookie "${name}" as JSON:`, e);
    return null;
  }
};